export function getGaClientId(): string | undefined {
  const cookies = window.document.cookie.split('; ');
  const gaCookie = cookies.find((item) => item.startsWith('_ga='));

  if (!gaCookie) {
    return;
  }

  return gaCookie.replace(/_ga=GA\d.\d./, '');
}

export function getGclid(): string | undefined {
  const cookies = window.document.cookie.split('; ');
  const gclidCookie = cookies.find((item) => item.startsWith('_gcl_aw='));

  if (!gclidCookie) {
    return;
  }

  return gclidCookie.split('.').pop();
}
